var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"temp"},[_c('dv-scroll-ranking-board',{staticStyle:{"height":"90%","border-top":"0.125rem solid rgba(1, 153, 209, .5)"},attrs:{"config":_vm.config}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }